/**
 * 5.0.8.2 Profile - Enterprise Admin - Learning Credits
 * UX: https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=3631%3A19753
 */
// @react
import React from 'react'
// @design
import { makeStyles } from '@material-ui/core/styles'
// @components
// @module Components

const useStyles = makeStyles({
  root: {},
})

const LearningCredits = () => {
  const classes = useStyles()

  /******************************************
   * PROPS
   ******************************************/

  /******************************************
   * STATE
   ******************************************/

  /******************************************
   * HOOKS
   ******************************************/

  /******************************************
   * FUNCTIONS
   ******************************************/

  return <div className={classes.root}>LearningCredits tab content</div>
}

export default LearningCredits
